import classnames from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import { ROUTES } from "shared/constants";
import { AppState } from "shared/data/reducers";
import formatUrl from "shared/lib/formatUrl";

import FormattedMessage from "@components/UI/FormattedMessage";
import IconChevronLeft from "@components/UI/Icons/ChevronLeft";
import Link from "@components/UI/Link";

type HomepageUrls = Record<string, string>;

interface BackToHomepageLinkProps {
  className?: string;
}

function BackToHomepageLink({ className }: BackToHomepageLinkProps) {
  const { homepageUrls, currentLanguage, textStorage } = useSelector(
    (state: AppState) => ({
      homepageUrls: state.storage.frontendSettings?.dealerFrontendSettings
        ?.homepageUrls as HomepageUrls | undefined,
      currentLanguage: state.requestorConfig.currentLanguage,
      textStorage: state.requestorConfig.textStorage,
    })
  );

  const languageCode = currentLanguage === "cs" ? "cz" : currentLanguage;
  const homepageUrl =
    (homepageUrls && (homepageUrls[languageCode] || homepageUrls.default)) ||
    ROUTES.HOME;
  const isCustomHomepageUrlDefined =
    homepageUrls?.default !== "" && homepageUrls?.default !== undefined;

  return (
    <Link
      noParams={isCustomHomepageUrlDefined}
      href={isCustomHomepageUrlDefined ? formatUrl(homepageUrl) : ROUTES.HOME}
    >
      <a
        className={classnames(
          "special-offers-back-to-homepage-link",
          className
        )}
      >
        <span className="label-button-back-result bold">
          <span className="icon-button-back-result-desktop">
            <IconChevronLeft size={20} />
          </span>
          {textStorage?.["BestOffers.backToHomepage"] || (
            <FormattedMessage id="BestOffers.backToHomepage" />
          )}
        </span>
      </a>
    </Link>
  );
}

export default BackToHomepageLink;
